import React from "react";
import PropTypes from "prop-types";
import { Select, Row, Col, Form } from "antd";
import {
  GrantSectionHeading,
  TableLabel,
  SubSectionLabel,
  InputWrapper,
  FormContainer,
  GrantDropdown,
  SelectOptionWrapper,
} from "../../style";
import { BlurContainer, BlurOverlay } from "../../../../../../CommonComponents/commonStyles";

function GrantAllocationForm({
  isEnabled,
  allocationPref,
  onChange,
  children,
  disabled = false,
  grantSectionHeading = "Grant Allocation",
  grantSectionDescription = "Next, decide how you will allocate your grant recommendation.",
  isGa=false,
  scheduleType="oneTime",
  showAllSharesColumn=true
}) {
  return (
    <BlurContainer>
      <BlurOverlay isEnabled={isEnabled} />
      <GrantSectionHeading>{ grantSectionHeading }</GrantSectionHeading>
      <TableLabel className="mb-20 mb-30">
        { grantSectionDescription }
      </TableLabel>
      <SubSectionLabel normalLetter>Select allocation preference {isGa && '*'}</SubSectionLabel>
      <FormContainer className="mt-20">
        <Row>
          <Col lg={11} span={24}>
            <Form.Item>
              <InputWrapper>
                <GrantDropdown
                  id="selallocationPref"
                  value={allocationPref}
                  onChange={onChange}
                  disabled={disabled}
                  role = {false}
                  aria-label="allocationPreference"
                >
                  <Select.Option value="weightedAllocations">
                    <SelectOptionWrapper>
                      Grant allocation by weighted percentage
                    </SelectOptionWrapper>
                  </Select.Option>
                  <Select.Option value="perDollarAmount">
                    <SelectOptionWrapper>
                      Grant allocation by percentage or dollar amount
                    </SelectOptionWrapper>
                  </Select.Option>
                  {
                    !isGa && scheduleType !== "recurring" && showAllSharesColumn && <Select.Option value="entireBalance">
                    <SelectOptionWrapper>
                    Entire balance of investment options
                    </SelectOptionWrapper>
                  </Select.Option>
                  }
                </GrantDropdown>
              </InputWrapper>
            </Form.Item>
          </Col>
        </Row>
      </FormContainer>
      <Row>
        {allocationPref === 'weightedAllocations' && <TableLabel className="mt-20 mb-30">
          {isGa ? 
          "*The specified granted amount will be allocated based on a percentage of the account's overall holdings." : 
          "The specified allocation will be weighted based on current account holdings."}
        </TableLabel>}
      </Row>
      <Row>
        <Col lg={24} md={24} xs={24}>
          {children}
        </Col>
      </Row>
    </BlurContainer>
  );
}

GrantAllocationForm.propTypes = {
  isEnabled: PropTypes.bool,
  allocationPref: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  children: PropTypes.elementType,
  disabled:PropTypes.bool,
  grantSectionHeading: PropTypes.string,
  grantSectionDescription: PropTypes.string,
  isGa: PropTypes.bool,
  scheduleType: PropTypes.string,
  showAllSharesColumn: PropTypes.bool
}

export default GrantAllocationForm;
